import Accordioncommon from "@frameworks/web/components/generic/Accordion/accordion";
import React from "react";
import { SupportTabAcc } from "../constant";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import RightAccordiancontent from "../CommonComponent/RightAccordiancontent";
import { useNavigate } from "react-router-dom";
import { getQueryParameterName } from "@frameworks/web/utils/urlHelper";
export var supportData = [
    { dataHead: "FAQs", navigateUrl: "/faqs" },
    { dataHead: "Your Wealth Advisors", navigateUrl: "/wealth-advisor" },
    { dataHead: "Contact Us", navigateUrl: "/contactus" },
];
var SupportTab = function () {
    var device = DeviceContext();
    var Section = getQueryParameterName("section");
    var navigate = useNavigate();
    var FaqNavigate = function () {
        navigate("/faqs");
    };
    return (React.createElement(React.Fragment, null, device && device.isDesktop ? (React.createElement(React.Fragment, null,
        React.createElement("div", null,
            React.createElement(RightAccordiancontent, { heading: React.createElement(React.Fragment, null,
                    React.createElement("span", { className: "DMSansNormal_20_400 txt-midnight-blue" },
                        React.createElement("strong", null, "FAQs"))), subHeading: "", rightContent: "", rightIcon: true, onClick: FaqNavigate })),
        React.createElement("div", null,
            React.createElement(Accordioncommon, { AccordionArray: SupportTabAcc, defaultActiveKey: Section, parentClass: "common-accordian support-additional-section common-accordian-big-icon no-icon-bg" })))) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "pb-3" }, supportData.map(function (supportData) {
            return (React.createElement(RightAccordiancontent, { heading: supportData.dataHead, subHeading: "", rightContent: "", rightIcon: true, onClick: function () {
                    navigate(supportData.navigateUrl);
                } }));
        }))))));
};
export default SupportTab;
